import { useCallback, useContext } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { setKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { useEditorActions, utils } from './useEditorActions';
import DefaultNullValueRecord from 'customer-data-filters-ui/filterQueryFormat/DefaultNullValueRecord';
import { swapOperator } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
import { makeConditionHashKey } from './useNullValueState';
import { useGetOperators } from './useGetOperators';
import { useStrategy } from './useStrategy';
import { useValidateCondition } from './useValidateCondition';
export const useFieldConditionChange = (filterFamily, conditionPath, condition) => {
  const {
    data,
    nullValueState,
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    validateCondition
  } = useValidateCondition();
  const {
    onChangeInternal
  } = useEditorActions();
  const {
    getOperators,
    getRefinementOperators
  } = useGetOperators();
  const {
    getValueResolver
  } = useStrategy();
  const onConditionChange = useCallback(newCondition => {
    const newInternalDraftValue = setKeyPath(conditionPath, newCondition, internalDraftValue);
    onChangeInternal(newInternalDraftValue);
  }, [conditionPath, internalDraftValue, onChangeInternal]);
  const onFieldConditionFieldChange = newField => {
    const newCondition = utils.getNewConditionForChangedField(filterFamily, condition, newField, getOperators, getRefinementOperators, getValueResolver, internalDraftValue, data);
    onConditionChange(newCondition);
  };
  const onFieldConditionValueChange = useCallback((newCondition, shouldValidate = true) => {
    if (shouldValidate) {
      const validatedNewCondition = validateCondition(filterFamily, newCondition);
      onConditionChange(validatedNewCondition);
      return;
    }
    onConditionChange(newCondition.remove('errors'));
  }, [filterFamily, onConditionChange, validateCondition]);
  const onFieldConditionOperatorChange = newOperator => {
    let newCondition = swapOperator(newOperator, condition);
    const hashKey = makeConditionHashKey(newCondition, conditionPath);
    const defaultNullValue = nullValueState.defaultNullValueByOperator[hashKey] || DefaultNullValueRecord();
    newCondition = newCondition.set('defaultNullValue', defaultNullValue);
    onFieldConditionValueChange(newCondition, false);
  };
  const onFieldConditionValueAndOperatorChange = (newOperator, newCondition) => {
    let updatedCondition = swapOperator(newOperator, newCondition);
    const hashKey = makeConditionHashKey(updatedCondition, conditionPath);
    const defaultNullValue = nullValueState.defaultNullValueByOperator[hashKey] || DefaultNullValueRecord();
    updatedCondition = updatedCondition.set('defaultNullValue', defaultNullValue);
    onFieldConditionValueChange(updatedCondition, false);
  };
  return {
    onFieldConditionFieldChange,
    onFieldConditionValueChange,
    onFieldConditionOperatorChange,
    onFieldConditionValueAndOperatorChange
  };
};